<template>
  <li :class="styleMain">
    <div :class="wrapperClass">
      <span class="id">{{ actionId }}</span>
      <div class="background" />
      <div class="backgroundBottom" />
      <action-icon :action="action" />
      <el-checkbox v-model="open" :class="openClass"/>
      <action-minute :action="action" @focus="setFocusStatus" />
      <action-category :action="action" />
      <action-date :action="action" />
      <action-time :action="action" />
      <action-stopwatch :action="action" />
      <action-active :action="action" />
      <action-status :action="action" :focus="focusStatus" @focus="setFocusStatus"/>
      <component
        v-for="(category, index) in categoryCompenents"
        :key="index"
        :is="category"
        :action="action"
      />
    </div>
  </li>
</template>

<script>
import ActionActive from './ActionActive'
import ActionCategory from './ActionCategory'
import ActionChance from './ActionChance'
import ActionDate from './ActionDate'
import ActionDetail1 from './ActionDetail1'
import ActionDestination from './ActionDestination'
import ActionDestinationPass from './ActionDestinationPass'
import ActionDestinationShoot from './ActionDestinationShoot'
import ActionIcon from './ActionIcon'
import ActionMinute from './ActionMinute'
import ActionOrigin from './ActionOrigin'
import ActionOriginShoot from './ActionOriginShoot'
import ActionOwngoal from './ActionOwngoal'
import ActionPersonAssist from './ActionPersonAssist'
import ActionPersonAssistStriker from './ActionPersonAssistStriker'
import ActionPersonGoalkeeper from './ActionPersonGoalkeeper'
import ActionPersonPasser from './ActionPersonPasser'
import ActionPersonPlayer from './ActionPersonPlayer'
import ActionPersonReceiver from './ActionPersonReceiver'
import ActionPersonShooter from './ActionPersonShooter'
import ActionPersonStriker from './ActionPersonStriker'
import ActionPersonSubstitued from './ActionPersonSubstitued'
import ActionPersonSubstitute from './ActionPersonSubstitute'
import ActionStatus from './ActionStatus'
import ActionStopwatch from './ActionStopwatch'
import ActionTeam from './ActionTeam'
import ActionTime from './ActionTime'

export default {
  name: 'SportFootballMatchAction',
  components: {
    ActionActive,
    ActionCategory,
    ActionDate,
    ActionDetail1,
    ActionDestination,
    ActionDestinationPass,
    ActionDestinationShoot,
    ActionIcon,
    ActionMinute,
    ActionOrigin,
    ActionOriginShoot,
    ActionOwngoal,
    ActionPersonAssist,
    ActionPersonAssistStriker,
    ActionPersonGoalkeeper,
    ActionPersonPasser,
    ActionPersonPlayer,
    ActionPersonReceiver,
    ActionPersonShooter,
    ActionPersonStriker,
    ActionPersonSubstitued,
    ActionPersonSubstitute,
    ActionChance,
    ActionStatus,
    ActionStopwatch,
    ActionTeam,
    ActionTime
  },
  data () {
    return {
      focusStatus: false
    }
  },
  props: {
    action: Object
  },
  computed: {
    actionId () { return this.action.id },
    categoryCompenents () {
      return this.action.category.components
    },
    open: {
      get () { return this.action.open },
      set (value) { this.action.open = value }
    },

    wrapperClass () { return 'wrapper' + (this.open ? '' : ' close') },
    openClass () { return ['sportFootballMatchActionOpen', this.action.homeAway] },

    styleMain () {
      const style = ['sportFootballMatchAction']
      if ([21, 22].indexOf(this.action.typeId) > -1) {
        style.push('timeout')
      }

      return style
    }
  },
  methods: {
    setFocusStatus (value) {
      this.focusStatus = value
    }
  }
}
</script>

<style>
.sportFootballMatchAction{
  margin-bottom: 15px;
}
.sportFootballMatchAction .wrapper {
  display: grid;
  grid-template-columns: 55px 25px 60px 1fr 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: 35px;
  grid-gap: 9px 4px;
  grid-template-areas:
    "icon open minute category category person person person2 person2"
    "id id owngoal person3 person3 origin origin detail1 detail1"
    ". . team date time second . . active"
    ;
  justify-items: stretch;
  padding: 5px 5px 5px 0;
}
.sportFootballMatchAction .wrapper > div {
  align-self:center
}
.sportFootballMatchAction .wrapper.close {
  grid-template-rows: 35px 0 0;
  grid-gap: 5px 4px;
}
.sportFootballMatchAction .wrapper.close > div {
  max-height:100%;
  overflow:hidden;
  box-sizing: border-box;
}
.sportFootballMatchAction .wrapper > .background {
  position:relative;
  grid-column: 3 / 10;
  grid-row: 1 / 3;
  align-self: initial;
  background-color: var(--color-background-grey);
  border-radius: 6px 6px 0 0;
  margin:-5px
}
.sportFootballMatchAction.timeout .wrapper > .background {
  background-color: var(--color-background-offset);
}
.sportFootballMatchAction .wrapper.close > div.background {
  border-radius: 6px;
  max-height:45px;
}
.sportFootballMatchAction .wrapper > .backgroundBottom {
  position:relative;
  grid-column: 3 / 10;
  grid-row: 3;
  align-self: initial;
  background-color: var(--color-background-grey);
  border-radius: 0 0 6px 6px;
  margin:-3px -5px -5px -5px
}
.sportFootballMatchAction.timeout .wrapper > .backgroundBottom {
  background-color: var(--color-background-offset);
}
.sportFootballMatchAction .wrapper > .id {
  position:relative;
  grid-area:id;
  font-size:12px;
  color:var(--color-font-grey-light)
}
.sportFootballMatchActionOpen {
  grid-area: open;
  align-self: center
}
.sportFootballMatchActionOpen .el-checkbox__input.is-checked .el-checkbox__inner,
.sportFootballMatchActionOpen .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: var(--color-background-grey-dark);
  border-color: var(--color-background-grey-dark);
}
.sportFootballMatchActionOpen.home .el-checkbox__input.is-checked .el-checkbox__inner,
.sportFootballMatchActionOpen.home .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: var(--color-team-home);
  border-color: var(--color-team-home);
}
.sportFootballMatchActionOpen.away .el-checkbox__input.is-checked .el-checkbox__inner,
.sportFootballMatchActionOpen.away .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: var(--color-team-away);
  border-color: var(--color-team-away);
}
.sportFootballMatchActionOpen .el-checkbox__input.is-focus .el-checkbox__inner{
  border-color: var(--color-background-grey-dark);
}
.sportFootballMatchActionOpen.home .el-checkbox__input.is-focus .el-checkbox__inner{
  border-color: var(--color-team-home);
}
.sportFootballMatchActionOpen.away .el-checkbox__input.is-focus .el-checkbox__inner{
  border-color: var(--color-team-away);
}
.sportFootballMatchActionOpen .el-checkbox__inner:hover {
    border-color: var(--color-background-grey-dark);
}
.sportFootballMatchActionOpen.home .el-checkbox__inner:hover {
    border-color: var(--color-team-home);
}
.sportFootballMatchActionOpen.away .el-checkbox__inner:hover {
    border-color: var(--color-team-away);
}
</style>
